import ReportsSpreadsheetCell from 'modules/reports/components/Spreadsheet/Cell'
import {useReportsSpreadsheetContext} from 'modules/reports/components/Spreadsheet/ReportsSpreadsheet.context'
import usePrefix from 'modules/reports/hooks/prefix'
import React from 'react'
import ReportsSpreadsheetRowContext, {
  ReportsSpreadsheetRowContextProps,
} from './ReportsSpreadsheetRow.context'
import useStyles from './ReportsSpreadsheetRow.styles'

type Props = {
  data: any
  index: number
}

function ReportsSpreadsheetRow(props: Props) {
  const {data, index} = props
  const classes = useStyles()
  const {prefix, columns, onNewColumn} = useReportsSpreadsheetContext()
  const p = usePrefix(`${prefix}-row-${index}`)

  const contextValue: ReportsSpreadsheetRowContextProps = {data, index, prefix: p()}

  return (
    <tr className={classes.root} data-testid={p()}>
      <ReportsSpreadsheetRowContext.Provider value={contextValue}>
        {columns.map((column, columnIndex) => (
          <ReportsSpreadsheetCell key={columnIndex} column={column} />
        ))}
      </ReportsSpreadsheetRowContext.Provider>

      {index === 0 && onNewColumn && <td rowSpan={data.length} />}
    </tr>
  )
}

export default ReportsSpreadsheetRow
